<bizz-modal modalSize="lg" title="InstancePermissions" [contentTemplate]="contentTemplateRef"
    [footerTemplate]="footerTemplateRef"></bizz-modal>

<ng-template #contentTemplateRef>
    <bizz-permissions-data class="overflow-y-auto" [data]="data"></bizz-permissions-data>
</ng-template>

<ng-template #footerTemplateRef>
    <div class="modal-buttons">
        <button class="default" type="button" (click)="dialogRef.close()">
            {{ 'Cancel' | translate }}
        </button>
        <button class="save min-w-16" type="submit" (click)="save()">
            <bizz-icon class="size-4" iconName="circle-check"></bizz-icon>
            {{ 'Save' | translate }}
        </button>
    </div>
</ng-template>